import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  PageContainer,
  ImageTextContainer,
  BannerImage,
  TextBelowImage,
  TextTitle,
  ImageSections,
  ImageBox,
  ImageBoxImg,
  ImageBoxButton,
  SubscribeSection,
  SubscribeHeading,
  SubscribeDescription,
  SubscribeForm,
  SubscribeInput,
  SubscribeButton,
  SuccessMessage,
} from "../Styles/Styleshome.js";
import bb from '../Images/bb.jpeg';
import r from '../Images/r.jpeg';
import b from '../Images/b.jpeg';
import p from '../Images/p.jpeg';

const HomePage = () => {
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(""); // State for success message

  const handleSignUp = () => {
    setSuccessMessage("Thank you for signing up! You'll receive updates soon.");
    setTimeout(() => {
      setSuccessMessage(""); // Clear the message after 5 seconds
    }, 5000);
  };

  return (
    <PageContainer>
      <ImageTextContainer>
        {/* Banner Image as a normal image */}
        <BannerImage src={bb} alt="Aspen Banner" />

        {/* Text Below Image */}
        <TextBelowImage>
          <TextTitle>
            Real estate news, information, Blogs, Reports, and insights
          </TextTitle>
        </TextBelowImage>
      </ImageTextContainer>

      <ImageSections>
        {/* Image Box 1 */}
        <ImageBox>
          <ImageBoxImg src={r} alt="Real Estate" />
          <ImageBoxButton onClick={() => navigate("/real-estate-reports")}>
            Go To Real Estate Reports
          </ImageBoxButton>
        </ImageBox>

        {/* Image Box 2 */}
        <ImageBox>
          <ImageBoxImg src={p} alt="Podcasts" />
          <ImageBoxButton onClick={() => navigate("/podcasts")}>
            Go To Podcasts
          </ImageBoxButton>
        </ImageBox>

        {/* Image Box 3 */}
        <ImageBox>
          <ImageBoxImg src={b} alt="Blog Posts" />
          <ImageBoxButton onClick={() => navigate("/blog")}>
            Go To Blog Posts
          </ImageBoxButton>
        </ImageBox>
      </ImageSections>

      {/* Subscribe Section */}
      <SubscribeSection>
        <SubscribeHeading>Subscribe</SubscribeHeading>
        <SubscribeDescription>
          Sign up to receive email updates
        </SubscribeDescription>
        <SubscribeForm>
          <SubscribeInput type="email" placeholder="Email Address" />
          <SubscribeButton onClick={handleSignUp}>Sign Up</SubscribeButton>
        </SubscribeForm>
        {successMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
      </SubscribeSection>
    </PageContainer>
  );
};

export default HomePage;
